import { LINK_CONFIG } from '../link-config';
var ɵ0 = LINK_CONFIG;
var AppModule = /** @class */ (function () {
    function AppModule() {
    }
    return AppModule;
}());
export { AppModule };
export { ɵ0 };
